import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../FormGroup/FormGroup';
import { useTextField } from 'react-aria';
import { charLengths, relativeLengths, getWidthClass } from 'client/utils/constants/GDS/js/widths';

const inputTypes = ['text', 'search', 'url', 'tel', 'email', 'password'];
const inputModes = ['text', 'numeric', 'tel', 'search', 'eamil', 'url'];

const TextInput = ({ enableSpellCheck, labelAsTitle, width, ...props }) => {
    const ref = React.useRef();
    const { inputProps, errorMessageProps, labelProps, descriptionProps } = useTextField(props, ref);

    return (
        <FormGroup errorMessage={props.errorMessage} errorMessageProps={ errorMessageProps } label={props.label} labelAsTitle={labelAsTitle} labelProps={ labelProps } description={props.description} descriptionProps={ descriptionProps } data-testid={props['data-testid']}>
            <input
                { ...inputProps }
                className={['govuk-input', (props.errorMessage ? 'govuk-input--error' : null), getWidthClass(width)].join(' ')}
                data-testid = {props['data-testid'] ? props['data-testid'] + '-input' : null}
                spellCheck={enableSpellCheck}
                onChange={props.onChange}
                onBlur={props.onBlur}
            />
        </FormGroup>
    );
};

TextInput.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    labelAsTitle: PropTypes.bool,
    description: PropTypes.string,
    value: PropTypes.string,
    enableSpellCheck: PropTypes.bool,
    errorMessage: PropTypes.string,
    width: PropTypes.oneOf([...relativeLengths, ...charLengths]),
    inputMode: PropTypes.oneOf([...inputModes]),
    'data-testid': PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    type: PropTypes.oneOf([...inputTypes])
};

TextInput.defaultProps = {
    enableSpellCheck: true,
    labelAsTitle: false,
    width: 'full',
    inputMode: 'text',
    type: 'text'
};

export default TextInput;
